import { BMCard, BMPrimitives, BMText } from "@traveloka/district-bloom";
import { Image, StyleSheet } from "react-native";
import BMView from "../../../../components/View/BMView";
import { useMobileContentResource } from "../../../../core/resource/MobileResourceProvider";
import { formatMessage } from "../../../../utils";
import { HotelSearchFormResource } from "../types";

type Props = {
  query: string;
  resource: HotelSearchFormResource;
};

export default function EmptyResult(props: Props) {
  const { resource, query } = props;
  const { image } = resource;
  const { CorporateHotelSearchForm } = useMobileContentResource();
  return (
    <BMCard style={styles.card} layout="COMPACT" elevation="BOX">
      <BMView row align="center" spacing="md">
        <Image
          alt={resource.image.magnifyingGlass.altText}
          source={{ uri: image.magnifyingGlass.path }}
          style={styles.image}
        />
        <BMText ink="BMStyleTextInkPrimary" variant="uiLarge" numberOfLines={1}>
          {formatMessage(CorporateHotelSearchForm.destinationEmptyTitle, {
            keyword: query,
          })}
        </BMText>
      </BMView>
      <BMText
        style={styles.subTitle}
        variant="uiNormalLi"
        ink="BMStyleTextInkSecondary"
      >
        {CorporateHotelSearchForm.destinationEmptySubTitle}
      </BMText>
    </BMCard>
  );
}

const styles = StyleSheet.create({
  card: {
    marginTop: BMPrimitives.BMSize.lg,
    marginHorizontal: BMPrimitives.BMSize.md,
  },
  image: {
    width: 48,
    height: 48,
  },
  subTitle: {
    marginTop: BMPrimitives.BMSize.sm,
    marginBottom: BMPrimitives.BMSize.lg,
  },
});
